import React from "react";

export default function Loading({ absolute = true }) {
  return (
    <div
      style={{
        position: absolute ? "absolute" : "fixed",
        inset: "0",
        background: "rgba(255,255,255,0.5)",
        display: "grid",
        placeItems: "center",
        zIndex: 9999,
      }}>
      <div className="spinner-border" role="status" style={{ height: "4rem", width: "4rem" }}></div>
    </div>
  );
}
